import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'
import * as request from 'services/request'
import notify from 'utils/notification'

import MediaLoading from '../tweet-input/media/media-loading'
import './media-preview.css'

class MediaPreviewModal extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      show: true,
      media: null,
      loading: true,
      error: false
    }
    this.closeModal = this.closeModal.bind(this)
  }

  closeModal () {
    this.setState({ show: false })

    const { close } = this.props
    setTimeout(() => {
      close()
      this.setState({
        show: true,
        loading: true
      })
    }, 500)
  }

  async getMedia () {
    const { id, type, data } = this.props

    if (!id) return // only get media when we have something to get

    if (type === 'gif' || type === 'video') {
      this.setState({
        media: data,
        loading: false
      })
      return
    }

    this.setState({
      loading: true
    })

    try {
      const response = await request.authorized(`/media/${id}`)
      const blob = await response.blob()
      const objectURL = window.URL.createObjectURL(blob)
      this.setState({
        media: objectURL,
        loading: false
      })
    } catch (error) {
      notify.error({
        title: `Error loading media`,
        message: `Could not load media id '${id}': ${error.message}`
      })
    }
  }

  componentDidUpdate (prevProps) {
    // only get media when showing modal, not when closing it
    if (!prevProps.id && this.props.id) this.getMedia()
  }

  render () {
    const { id, name, type } = this.props
    const { loading } = this.state
    const decodedName = decodeURI(name)
    if (!id) return null

    let media
    if (loading) {
      media = (
        <MediaLoading className='br-media-loading'>
          <div className='lds-ellipsis'>
            <div />
            <div />
            <div />
            <div />
          </div>
        </MediaLoading>
      )
    } else {
      switch (type) {
        case 'image':
        case 'gif':
          media = (
            <img
              src={this.state.media}
              alt={decodedName}
              className='br-media-preview-area'
            />
          )
          break
        case 'video':
          media = (
            <video
              src={this.state.media}
              alt={decodedName}
              className='br-media-preview-area'
              controls
            />
          )
          break
        default:
          media = null
          break
      }
    }

    return (
      <Modal show={this.state.show} onHide={this.closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>{decodedName}</Modal.Title>
        </Modal.Header>
        <Modal.Body className='br-media-preview-modal'>{media}</Modal.Body>
      </Modal>
    )
  }
}

MediaPreviewModal.propTypes = {
  id: PropTypes.string,
  close: PropTypes.func,
  type: PropTypes.string,
  name: PropTypes.string,
  data: PropTypes.string
}

export default MediaPreviewModal



// WEBPACK FOOTER //
// ./src/pages/widgets/form/media-preview/index.js